class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.submitButton = this.querySelector('button.search__button:not([type="button"])');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this))
    }

    if (this.input && this.submitButton) {
      // Pressing the button blurs the input, so record whether it was open before that happens.
      this.submitButton.addEventListener('pointerdown', () => {
        this.inputFocusedOnPress = document.activeElement === this.input;
      });
      this.submitButton.addEventListener('click', this.onSubmitButtonClick.bind(this));
    }
  }

  isCollapsedOnMobile() {
    return Boolean(this.closest('.hide-search-bar-mobile')) && window.matchMedia('(max-width: 768px)').matches;
  }

  onSubmitButtonClick(event) {
    // Keyboard submits have no pointerdown, so fall back to the current focus.
    const inputWasOpen = this.inputFocusedOnPress ?? document.activeElement === this.input;
    this.inputFocusedOnPress = undefined;
    if (inputWasOpen || !this.isCollapsedOnMobile()) return;

    // The collapsed search bar only opens on the first tap; submitting a prefilled query would reload the page.
    event.preventDefault();
    this.input.focus();
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden')
    } else if (this.input.value.length === 0  && !resetIsHidden) {
      this.resetButton.classList.add('hidden')
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a')
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
